import {getEventDelay} from './get-event-delay';
import {throttle} from './throttle';

export function adaptiveBg() {
  let win = window;
  let $win = $(win);
  let itemsGlobal = [];
  let attrName = 'data-src';
  let attrNameMob = attrName + '-mob';

  function addItems($items) {
    let items = $items || $('.adaptive-bg[' + attrNameMob + ']');

    items.each(function () {
      let $item = $(this);

      itemsGlobal.push({
        src: $item.attr(attrName),
        srcMob: $item.attr(attrNameMob),
        $item: $item
      });
    });
  }

  function run() {
    if (itemsGlobal.length) {
      let windowWidth = win.innerWidth;
      let windowHeight = win.innerHeight;
      let isLandscape = windowHeight < windowWidth;
      let isLargeBreakpoint = windowWidth >= 1024;

      $.each(itemsGlobal, function (index, item) {
        let src = (isLandscape || isLargeBreakpoint) ? item.src : item.srcMob;

        item.$item.css('background-image', 'url(' + src + ')');
      });
    }
  }

  $win.on('load', function () {
    addItems();
    run();

    ['resize', 'orientationchange'].map(function (item) {
      let eventDelay = getEventDelay(item);
      $win.on(item, throttle(run, eventDelay));
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/adaptive-bg.js